import { render, staticRenderFns } from "./AwaitPayment.vue?vue&type=template&id=530524df"
import script from "./AwaitPayment.vue?vue&type=script&lang=js"
export * from "./AwaitPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports